'use client';

import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { defaultNS } from '@/app/i18n/settings';

import i18next from './i18next';

const runsOnServerSide = typeof window === 'undefined';

export function useT(ns: string | string[] = defaultNS, options?: Record<string, any>) {
  const lng = useParams()?.lng;
  if (typeof lng !== 'string') throw new Error('useT is only available inside /app/[lng]');

  // 항상 훅 호출
  const [activeLng, setActiveLng] = useState<string | undefined>(i18next.resolvedLanguage);

  useEffect(() => {
    if (activeLng === i18next.resolvedLanguage) return;
    setActiveLng(i18next.resolvedLanguage);
  }, [activeLng]);

  useEffect(() => {
    if (!lng || i18next.resolvedLanguage === lng) return;
    i18next.changeLanguage(lng);
  }, [lng]);

  // 서버사이드에서 언어 변경
  if (runsOnServerSide && i18next.resolvedLanguage !== lng) {
    i18next.changeLanguage(lng);
  }

  return useTranslation(ns, options);
}
